import React, { useRef, useState } from "react";
import { IconPatientJourney } from "../../../assets/icons/icon-patient-journey";
import TrialInformation from "./trial-information";
// import PatientScreening from "./patient-screening";
import CallLog from "./call-log";
import { CloseIcon } from "../../../assets/icons/close-icon-simple";
import PatientScreening from "./patient-journey";
import PatientJourneyIn from "./patient-journey";
import PatientScreen from "./patient-screen";
import AIAgentsCallLogs from "./ai-agents-call-logs";

const PatientJourney = ({ trialInfo, setTogglePj }) => {
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [aiCallLoading, setAICallLoading] = useState(true);
  const [callLogLoading, setCallLogLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("AI Agents call logs");

  const onMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const onMouseLeave = () => setIsDragging(false);
  const onMouseUp = () => setIsDragging(false);

  const onMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // drag speed
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <>
      <div className="w-[450px] bg-white h-full">
        <div
          className="border-b border-[#B2ACC9] w-full"
          style={{ borderColor: "rgb(200, 214, 230)" }}
        >
          <div className="flex justify-between items-center w-full px-5 py-6">
            <h2 className="font-semibold text-left ">Chat Details</h2>
            <button onClick={() => setTogglePj(false)}>
              <CloseIcon />
            </button>
          </div>
        </div>

        <div className="flex flex-col h-[calc(100vh-450px)]">
          <div className="p-5 pb-0 ">
            <div
              ref={scrollRef}
              className="w-full overflow-x-auto whitespace-nowrap no-scrollbar cursor-grab active:cursor-grabbing select-none"
              onMouseDown={onMouseDown}
              onMouseLeave={onMouseLeave}
              onMouseUp={onMouseUp}
              onMouseMove={onMouseMove}
            >
              <div className="flex w-max cursor-pointer mb-[25px]">
                {/* AI Agents call logs */}
                <div
                  style={{
                    color:
                      activeTab === "AI Agents call logs"
                        ? "#245CEA"
                        : "#1A1A1B",
                  }}
                  className="text-[15px] text-center font-semibold font-mont "
                  onClick={() => setActiveTab("AI Agents call logs")}
                >
                  AI Agents call logs
                  <div
                    className="border-b border-4 h-1 relative top-2 z-10 rounded-sm"
                    style={{
                      borderColor:
                        activeTab === "AI Agents call logs"
                          ? "#245CEA"
                          : "#C8D6E6",
                    }}
                  ></div>
                </div>

                {/* Spacer */}
                <div className="min-w-[25px] flex items-end">
                  <div
                    className="h-1 border-b border-4 relative top-2 z-10 w-full"
                    style={{ borderColor: "#C8D6E6" }}
                  ></div>
                </div>

                {/* Trial Information */}
                <div
                  style={{
                    color:
                      activeTab === "Trial Information" ? "#245CEA" : "#1A1A1B",
                  }}
                  className="text-[15px] text-center font-semibold font-mont "
                  onClick={() => setActiveTab("Trial Information")}
                >
                  Trial Information
                  <div
                    className="border-b border-4 h-1 relative top-2 z-10 rounded-sm"
                    style={{
                      borderColor:
                        activeTab === "Trial Information"
                          ? "#245CEA"
                          : "#C8D6E6",
                    }}
                  ></div>
                </div>

                {/* Spacer */}
                <div className="min-w-[25px] flex items-end">
                  <div
                    className="h-1 border-b border-4 relative top-2 z-10 w-full"
                    style={{ borderColor: "#C8D6E6" }}
                  ></div>
                </div>

                {/* Patient Journey */}
                <div
                  style={{
                    color:
                      activeTab === "Patient Journey" ? "#245CEA" : "#1A1A1B",
                  }}
                  className="text-[15px] text-center font-semibold font-mont "
                  onClick={() => setActiveTab("Patient Journey")}
                >
                  Patient Journey
                  <div
                    className="border-b border-4 h-1 relative top-2 z-10 rounded-sm"
                    style={{
                      borderColor:
                        activeTab === "Patient Journey" ? "#245CEA" : "#C8D6E6",
                    }}
                  ></div>
                </div>

                {/* Spacer */}
                <div className="min-w-[25px] flex items-end">
                  <div
                    className="h-1 border-b border-4 relative top-2 z-10 w-full"
                    style={{ borderColor: "#C8D6E6" }}
                  ></div>
                </div>

                {/* Call Log */}
                <div
                  style={{
                    color: activeTab === "Call Log" ? "#245CEA" : "#1A1A1B",
                  }}
                  className="text-[15px] text-center font-semibold font-mont "
                  onClick={() => setActiveTab("Call Log")}
                >
                  Manual Call Logs
                  <div
                    className="border-b border-4 h-1 relative top-2 z-10 rounded-sm"
                    style={{
                      borderColor:
                        activeTab === "Call Log" ? "#245CEA" : "#C8D6E6",
                    }}
                  ></div>
                </div>

                {/* Spacer */}
                <div className="min-w-[25px] flex items-end">
                  <div
                    className="h-1 border-b border-4 relative top-2 z-10 w-full"
                    style={{ borderColor: "#C8D6E6" }}
                  ></div>
                </div>

                {/* Patient Screening */}
                <div
                  style={{
                    color:
                      activeTab === "Patient Screening" ? "#245CEA" : "#1A1A1B",
                  }}
                  className="text-[15px] text-center font-semibold font-mont "
                  onClick={() => setActiveTab("Patient Screening")}
                >
                  Patient Screening
                  <div
                    className="border-b border-4 h-1 relative top-2 z-10 rounded-sm"
                    style={{
                      borderColor:
                        activeTab === "Patient Screening"
                          ? "#245CEA"
                          : "#C8D6E6",
                    }}
                  ></div>
                </div>
              </div>
            </div>

            {activeTab === "Trial Information" ? (
              <div>
                <TrialInformation trialInfo={trialInfo} />
              </div>
            ) : activeTab === "AI Agents call logs" ? (
              <div className="">
                <AIAgentsCallLogs
                  trialInfo={trialInfo}
                  loading={aiCallLoading}
                  setLoading={setAICallLoading}
                />
              </div>
            ) : activeTab === "Patient Journey" ? (
              <div className="">
                <PatientJourneyIn trialInfo={trialInfo} />
              </div>
            ) : activeTab === "Call Log" ? (
              <div className="">
                <CallLog
                  trialInfo={trialInfo}
                  loading={callLogLoading}
                  setLoading={setCallLogLoading}
                />
              </div>
            ) : activeTab === "Patient Screening" ? (
              <div className="">
                <PatientScreen trialInfo={trialInfo} />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientJourney;
